import { Color, DisplayMode, Engine, SceneMap, vec } from 'excalibur';

export const createEngine = (scenes?: SceneMap) => {
    const engine = new Engine({
        canvasElementId: 'game',
        width: 3840,
        height: 2160,
        backgroundColor: Color.fromHex('#000000'),
        displayMode: DisplayMode.FitScreen,
        pixelArt: true,
        physics: { gravity: vec(0, 800) },
        scenes: scenes ?? {},
    });

    engine.input.gamepads.enabled = true;
    engine.input.gamepads.setMinimumGamepadConfiguration({ axis: 4, buttons: 8 });

    return engine;
};
